export default __webpack_public_path__ + "static/media/ic_shareLoc.285c8691.png";